import { Fragment, useState } from "react";
import { VacancyProcessProps } from "storyblok/components";

import {
    AnimationStyle,
    FramerMotionWrapper,
    Icon,
    Icons
} from "components/ui";

import {
    Description,
    IconWrapper,
    StyledContainer,
    StyledScrollContainer,
    StyledStep,
    Title
} from "./VacancyProcess.styled";

export function VacancyProcess({ blok }: VacancyProcessProps): JSX.Element {
    const { title, step } = blok;
    const [selected, setSelected] = useState(0);

    const stepsContent = (
        <>
            {step.map((entry, index) => (
                <Fragment key={`${index}_${entry.title}`}>
                    <StyledStep onClick={() => setSelected(index)}>
                        <IconWrapper selected={selected === index}>
                            <Icon
                                icon={Icons[entry.icon]}
                                color={
                                    selected === index
                                        ? "var(--color-white)"
                                        : "var(--color-black)"
                                }
                                size={48}
                                aria-hidden="true"
                            />
                        </IconWrapper>
                        <Title selected={selected === index}>
                            {entry.title}
                        </Title>
                    </StyledStep>

                    {selected === index && (
                        <FramerMotionWrapper
                            animationType={AnimationStyle.FadeIn}
                            duration={0.5}
                        >
                            <Description index={index}>
                                {entry.description}
                            </Description>
                        </FramerMotionWrapper>
                    )}
                </Fragment>
            ))}
        </>
    );

    return (
        <StyledContainer>
            <h2>{title}</h2>

            <StyledScrollContainer vertical={false} horizontal>
                {stepsContent}
            </StyledScrollContainer>
        </StyledContainer>
    );
}
